<template>
  <report-list-page
      v-if="checkAccess('sites-summary-report')"
      page-title="Site Report"
      page-icon="mdi-group"
      :descending="true"
      :headers="headers"
      state-end-point="invoice.sitesSummaries"
      :actions="actions"
      :show-component="showComponent"
      item-key="id"
  />
</template>

<script>
import IsAuthenticated from "../../middleware/IsAuthenticated";
import ReportListPage from "../../components/ReportListPage";
export default {
  name: "SiteReport",
  components: {ReportListPage},
  mixins: [IsAuthenticated],
  data() {
    return {
      headers: [
        {
          text: 'Site ID',
          value: 'siteId'
        },
        {
          text: 'Site URL',
          value: 'siteUrl'
        },
        {
          text: 'Status',
          align: 'left',
          value: 'paymentStatus'
        },
        {
          text: 'Impression',
          value: 'impression'
        },
        {
          text: 'A. Price',
          align: 'right',
          value: 'generalAdminPrice'
        },
        {
          text: 'O.A. Price',
          align: 'right',
          value: 'othersAdminPrice'
        },
        {
          text: 'P. Amount',
          align: 'right',
          value: 'publishableAmount'
        },
        {
          text: 'W. Price',
          align: 'right',
          value: 'articleWritingPrice'
        },
        {
          text: 'Sub Total',
          align: 'right',
          value: 'total'
        },
        {
          text: 'Discount',
          align: 'right',
          value: 'discount'
        },
        {
          text: 'Total',
          align: 'right',
          value: 'excludeDiscountTotal'
        }
      ],
      actions: {
        load: 'loadSiteSummaryReports',
      },
      showComponent: {
        isUser: true,
        isStatus: true,
        isMethod: false,
        isEmail: true,
        isSite: true,
        isSummary: true,
        isAdminPrice: true,
      }
    }
  }
}
</script>

<style scoped>

</style>